const getHeaders = () => {
  const jwt = localStorage.getItem("onboarding_session");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwt}`,
  };
};

export const postRequest = async (
  path: string,
  data: Object,
  headers?: Object,
) => {
  const res = await fetch(path, {
    body: JSON.stringify(data),
    headers: {
      ...getHeaders(),
      ...(headers as any),
    },
    method: "POST",
  });

  return res.json();
};
